import { formatDateTime } from '@/modules/bags/functions/format-date.function';
import styles from './index.module.sass';
import { InputWithSign } from '@/modules/common/components/input-with-sign';
import calendarIcon from '@@/bags/images/calendar.svg';
import { CalendarPicker } from '@/modules/common/components/calendar-picker';
import { UiButton } from '@/modules/ui/components/ui-button';
import { useEffect } from 'react';
import { warehouseModel } from '@/entities/warehouse';
import { useStore } from 'effector-react';
import { WAREHOUSE_TYPES } from '@/entities/warehouse/store';

export const Actions = ({
  inputs,
  elemRef,
  setShowDatePicker,
  showDatePicker,
  onChangeInput,
  edit,
  isLoading,
  formId,
  onSubmit,
}: IArgs) => {
  const selectedWarehouse = useStore(warehouseModel.$warehouseInfo);

  return (
    <div className={styles.actions}>
      {inputs.fillDate && (
        <div
          className={styles.dateBlock}
          ref={elemRef}
          style={{ position: 'relative' }}
        >
          <span>дата заполнения</span>
          <InputWithSign
            autogrow={true}
            onClick={() => setShowDatePicker(!showDatePicker)}
            value={formatDateTime(inputs.fillDate, true) as string}
            onChange={() => {}}
            postfix={
              <img
                src={calendarIcon}
                style={{ cursor: 'pointer' }}
                onClick={() => setShowDatePicker(!showDatePicker)}
                alt="calendar"
              />
            }
            mask={[
              /\d/,
              /\d/,
              '.',
              /\d/,
              /\d/,
              '.',
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              ' ',
              /\d/,
              /\d/,
              ':',
              /\d/,
              /\d/,
            ]}
            placeholder="01.01.2025 00:00"
          />
          <CalendarPicker
            date={formatDateTime(inputs.fillDate, false) as any}
            allowFutureDate={false}
            setDate={(val: any) =>
              onChangeInput({
                fillDate: new Date(
                  val.year,
                  val.month - 1,
                  val.day,
                  val.hours,
                  val.minutes,
                ),
              })
            }
            visible={showDatePicker}
            closeFn={() => setShowDatePicker(false)}
          />
        </div>
      )}
      <UiButton
        label={
          selectedWarehouse
            ? selectedWarehouse.type === WAREHOUSE_TYPES.sleeve
              ? edit
                ? 'сохранить рукав'
                : 'добавить рукав'
              : edit
              ? 'сохранить'
              : 'добавить'
            : 'сохранить'
        }
        view="primary"
        type="submit"
        loading={isLoading}
        aria-loading={isLoading}
        htmlForm={formId}
        className={styles.buttonModified}
        onClick={(e) => onSubmit(e)}
      />
    </div>
  );
};

interface IArgs {
  inputs: any;
  elemRef: React.MutableRefObject<any>;
  setShowDatePicker: (val: boolean) => void;
  showDatePicker: boolean;
  onChangeInput: (values: { [key: string]: any }) => void;
  edit: boolean;
  isLoading: boolean;
  formId: string;
  onSubmit: (e: any) => void;
}
